import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import CreateOrEdit from "./from";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";
import CommomApproval from "../../../utils/CommomApproval";
import useGetDropDown from "../../../hooks/useFetchDropDown";

function MaintenanceIndex() {
  const ModelId = 3;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let { statusFilter } = location?.state || "";
  let value = {
    status:statusFilter||""
  }
  const { statusValue } = useGetStatusData({ value: ModelId });
  const { dropDownValue } = useGetDropDown({
    url: `/Frequency/`,
    value: "frequency_type",
  });
  const {
    completePercentage,
    getData: getDashboardData,
    isReveiw,
  } = useDashboardStatus({
    url: `/DashBoard/standard/${stdId}/maintenance/`,
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: statusFilter
      ? `/Maintenance/standard/${stdId}/`
      : `/Maintenance/standard/${stdId}/`,
    page: pageIndex,
    pageCount: dataCount,
    param: value,
  });
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleApprovalOnClose = () => setShowApprovalModal(false);

  async function clearFilter() {
    value={
      status:""
    }
    navigate(".", { replace: true, state: { statusFilter: null } });
    await getData(true);
  }

  return (
    <>
      <ViewTableIndex
        label="Maintenance"
        menu="Activity"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="activity_create"
        hasOverAll={true}
        OverAllPercentage={completePercentage}
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={() => setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={() => setShowImport(true)}
        hasImport={true}
        hasFilter={true}
        filterValue={statusFilter}
        clearFunction={clearFilter}
        hasApprove={true}
        ReviewStatus={isReveiw}
        ReviewFunction={() => setShowApprovalModal(true)}
      >
        <>
          {data &&
            data?.map((data, i) => (
              <tr
                className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                key={i}
              >
                <td className="px-2 py-1 text-gray-900 whitespace-nowrap text-center w-[5%] capitalize">
                  {data.serial_number || "#"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[35%] capitalize ">
                  {data?.task || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[15%] capitalize ">
                  {data?.frequency_name || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[15%] capitalize ">
                  {data?.status_id || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[15%] capitalize ">
                  {data?.comments||"-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[12%] capitalize flex justify-center items-center">
                  {data?.file_path?.length > 0 && <PaperClip />}
                </td>
                <td className="px-2 py-1 w-[3%] flex justify-center items-center">
                  <ViewMore
                    data={data}
                    satusData={statusValue}
                    fetcher={getData}
                    getCompletion={getDashboardData}
                    id={stdId}
                  />
                </td>
              </tr>
            ))}
        </>
      </ViewTableIndex>
      <CreateOrEdit
        visible={showMyModal}
        onClose={handleOnClose}
        refreshData={getData}
        satusData={statusValue}
        metaData={dropDownValue}
        getCompletion={getDashboardData}
        id={stdId}
      />
      <CommonXlsExport
        id={stdId}
        path={`maintenance`}
        name={`${standardDetailName} Maintenance ${
          standardStartDate &&
          NuDateFormat({ value: standardStartDate, format: "MMM-YYYY" })
        } ${standardEndDate && "to"} ${
          standardEndDate &&
          NuDateFormat({ value: standardEndDate, format: "MMM-YYYY" })
        }`}
        visible={showExport}
        onClose={() => {
          setShowExport(false);
        }}
      />

      <CommonImport
        url={`/Maintenance/standard/${stdId}/Import`}
        refreshData={getData}
        getFuction={getDashboardData}
        visible={showImport}
        onClose={() => setShowImport(false)}
        hasRemoveApproval={true}
        moduleId={ModelId}
        standardId={stdId}
      />

      <CommomApproval
        visible={showApprovalModal}
        onClose={handleApprovalOnClose}
        refreshData={getData}
        moduleId={ModelId}
        id={stdId}
        moduleName="Maintenance"
        standardName={standardDetailName}
        getCompletion={getDashboardData}
      />
    </>
  );
}

export default MaintenanceIndex;

const header = [
  {
    headone: <span>Sl&nbsp;No.</span>,
    width: "w-[5%]",
  },
  {
    headone: "Maintenance Task",
    width: "w-[35%]",
  },
  {
    headone: "Frequency",
    width: "w-[15%]",
  },
  {
    headone: "Status",
    width: "w-[15%]",
  },
  {
    headone: "Comments",
    width: "w-[15%]",
  },
  {
    headone: "Artefact",
    width: "w-[12%]",
  },
  {
    headone: " ",
    width: "w-[3%]",
  },
];
